import { ReportHandler } from 'web-vitals';

const reportWebVitals = (onPerfEntry?: ReportHandler): void => {
  // Default console logger if no handler provided
  const logger = onPerfEntry || ((metric) => {
    if (process.env.NODE_ENV === 'development') {
    }
  });
  
  import("web-vitals").then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
    getCLS(logger);
    getFID(logger);
    getFCP(logger);
    getLCP(logger);
    getTTFB(logger);
  });
};

export default reportWebVitals; 
